import { tableIcons } from '../../../../constants/assets'
import { cn } from '../../../../utils/cn'

type VehicleCellProps = {
  vehicle: string
  driverAssigned: boolean
  driverName?: string
  onAssignDriver?: () => void
}

/**
 * Vehicle name over the driver state. When no driver is set the state doubles as the
 * "assign a driver" affordance.
 */
export const VehicleCell = ({
  vehicle,
  driverAssigned,
  driverName,
  onAssignDriver,
}: VehicleCellProps) => (
  <div className="flex flex-col items-start gap-[2px]">
    <span className="whitespace-nowrap font-host text-[12px] font-medium leading-normal tracking-[-0.36px] text-black">
      {vehicle}
    </span>

    {driverAssigned ? (
      <span
        className="block max-w-[134px] break-words font-host text-[14px] font-medium leading-[1.35] text-dash-driver-on"
        title={driverName?.trim() || 'Driver Assigned'}
      >
        {driverName?.trim() || 'Driver Assigned'}
      </span>
    ) : (
      <button
        type="button"
        onClick={onAssignDriver}
        className={cn(
          'flex h-[19px] items-center gap-[3px]',
          onAssignDriver && 'transition-opacity hover:opacity-80 motion-reduce:transition-none',
        )}
      >
        <span className="whitespace-nowrap font-host text-[14px] font-medium leading-[1.5] text-dash-driver-off">
          Driver Unassigned
        </span>
        <img alt="" aria-hidden className="block size-[19px] max-w-none shrink-0" src={tableIcons.driverAdd} />
      </button>
    )}
  </div>
)
